import AppointmentItemActionButtons from './AppointmentItemActionButtons';
import AppointmentItemCollapsable from './AppointmentItemCollapsable';
import AppointmentItemContainer from './AppointmentItemContainer';
import AppointmentItemContent from './AppointmentItemContent';
import AppointmentItemDivider from './AppointmentItemDivider';
import AppointmentItemHeader from './AppointmentItemHeader';

const AppointmentItem = {
  ActionButtons: AppointmentItemActionButtons,
  Collapsable: AppointmentItemCollapsable,
  Container: AppointmentItemContainer,
  Content: AppointmentItemContent,
  Divider: AppointmentItemDivider,
  Header: AppointmentItemHeader,
};

export default AppointmentItem;
